<script setup>
import { computed, ref, watch } from 'vue';

const props = defineProps({
  modelValue: { type: [String, Number, null], default: null },
  options: { type: Array, default: () => [] },
  placeholder: { type: String, default: 'Selecione' },
  searchable: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue']);
const search = ref('');

watch(
  () => props.options,
  () => {
    search.value = '';
  }
);

const normalizedOptions = computed(() =>
  props.options.map(option =>
    typeof option === 'object'
      ? option
      : { label: String(option), value: option }
  )
);

const filteredOptions = computed(() => {
  if (!props.searchable || !search.value.trim()) {
    return normalizedOptions.value;
  }

  const term = search.value.trim().toLowerCase();
  return normalizedOptions.value.filter(option =>
    `${option.label}`.toLowerCase().includes(term)
  );
});
</script>

<template>
  <div class="flex w-full flex-col gap-2">
    <input
      v-if="searchable"
      v-model="search"
      type="text"
      class="h-10 rounded-lais-sm border border-lais-border bg-white px-3 text-[13px] text-lais-text placeholder:text-lais-text-muted focus:border-lais-primary focus:outline-none"
      :disabled="disabled"
      placeholder="Buscar..."
    />
    <select
      :value="modelValue"
      :disabled="disabled"
      class="h-10 w-full rounded-lais-sm border border-lais-border bg-white px-3 text-[14px] text-lais-text focus:border-lais-primary focus:outline-none"
      @change="emit('update:modelValue', $event.target.value)"
    >
      <option value="" disabled>{{ placeholder }}</option>
      <option
        v-for="option in filteredOptions"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>
